<app-layout-main
	[pageMetadata]="result()?.pageMetadata"
	[menuItems]="result()?.menuItems"
	[parentRoutes]="result()?.parentRoutes"
	[layoutSize]="result()?.layoutSize"
	[sharedData]="result()?.sharedData"
	(sharedDataUpdated)="handleSharedDataUpdated($event, true)"
>
	<div>
		<ng-template modTypeComponentDirective></ng-template>
	</div>
</app-layout-main>
